var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnswer1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 122 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.21,
    cy: 60.868,
    rx: 58.327,
    ry: 58.559,
    style: {
      fill: "#9a9a9d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.345,47.331c-0,-2.866 2.322,-5.187 5.188,-5.187c2.865,-0 5.187,2.321 5.187,5.187c-0,2.865 -2.322,5.184 -5.187,5.184c-2.866,0 -5.188,-2.319 -5.188,-5.184Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.283,47.331c-0,-2.866 2.321,-5.187 5.191,-5.187c2.86,-0 5.189,2.321 5.189,5.187c-0,2.865 -2.329,5.184 -5.189,5.184c-2.87,0 -5.191,-2.319 -5.191,-5.184Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.854,61.006l-4.25,-0c0,15.631 -6.33,29.771 -16.58,40.019c-10.251,10.25 -24.38,16.58 -40.02,16.58c-15.64,0 -29.778,-6.33 -40.028,-16.58c-10.247,-10.248 -16.579,-24.388 -16.58,-40.019c0.001,-15.644 6.333,-29.782 16.58,-40.032c10.25,-10.248 24.388,-16.578 40.028,-16.58c15.64,0.002 29.769,6.332 40.02,16.58c10.25,10.25 16.58,24.388 16.58,40.032l4.25,-0c0,-33.616 -27.24,-60.86 -60.85,-60.862c-33.613,0.002 -60.857,27.246 -60.858,60.862c0.001,33.61 27.245,60.85 60.858,60.85c33.61,-0 60.85,-27.24 60.85,-60.85Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.683,79.157l60.641,-0c1.17,-0 2.12,-0.951 2.12,-2.121c-0,-1.17 -0.95,-2.129 -2.12,-2.129l-60.641,-0c-1.174,-0 -2.125,0.959 -2.125,2.129c-0,1.17 0.951,2.121 2.125,2.121Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnswer1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/answer--1.e2ad8c27162c6f042a3bdc824feee8a6.svg";